import { render, staticRenderFns } from "./FooterJubilee.vue?vue&type=template&id=dfcdb9b8"
import script from "./FooterJubilee.vue?vue&type=script&lang=ts"
export * from "./FooterJubilee.vue?vue&type=script&lang=ts"
import style0 from "./FooterJubilee.vue?vue&type=style&index=0&id=dfcdb9b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports